import React, { useEffect, useState, useMemo } from "react";
import { Platform, StyleSheet, View, Dimensions } from "react-native";
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, ShimmerIconSizeTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, } from "@voltmoney/schema";
import { ModalAlignmentEnum } from '@voltmoney/types';
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import LottieView from "lottie-react-native";
import { Header } from "../../header/Header";
import { Button } from "../../button/Button";
import { ShimmerIcon } from "../../shimmerIcon/ShimmerIcon";
import BottomSheet from "../BottomSheet";
import { isMobile } from "../../stack/utils";
import { getScreenType } from "../bankSelectPage/BankSelect";
import { WebView as WV } from "react-native-webview";
// import LottieView from "lottie-react-native";
const AgreementInit = ({ height, triggerAction, continueAction, stepperData, goBackAction, loading, urlData, showClickForAgreementCard, openTabAction, showWaitingForResponseCard, pollAgreementStatusAction, showAgreementCompleteStatus, showAgreementFailureStatus, verificationSuccessAction, routeObj, showWebView }) => {
    const [successLottie, setSuccessLottie] = useState("");
    const [iLottieFetched, setLottieFetched] = useState(false);
    const [closeFailureCard, setCloseFailureCard] = useState(false);
    const successJsonLottie = "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json";
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null
    };
    useEffect(() => {
        fetch(successJsonLottie, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            setSuccessLottie(responseData);
            setLottieFetched(true);
        })
            .catch((error) => {
            console.log(error);
        });
    }, []);
    const _headerChild = useMemo(() => {
        return (React.createElement(Header, { id: "bt_autoPay_goBack", type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, title: "Review Agreement", onPress: () => {
                triggerAction({
                    ...goBackAction
                });
            } }));
    }, []);
    const renderVerification = () => {
        return !closeFailureCard && (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 260, width: '100%', closeFunction: () => {
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: showAgreementFailureStatus, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height + 10 : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, showAgreementCompleteStatus && iLottieFetched ? renderVerificationSuccess() : showWaitingForResponseCard ? renderWaitingHalfCard() : showAgreementFailureStatus ? renderVerificationFailure() : !showWebView ? renderContinueAgreementCard() : React.createElement(React.Fragment, null))));
    };
    const renderContinueAgreementCard = () => {
        return (React.createElement(View, { style: styles.successCard },
            React.createElement(Icon, { name: IconTokens.Redirecting, size: IconSizeTokens.Size56 }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: "Please click continue for agreement", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "Return to Volt after successful completion", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { id: "bt_AgreementInit_continue", type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Continue", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        triggerAction({
                            ...openTabAction,
                            payload: {
                                value: urlData
                            }
                        });
                    } }))));
    };
    const renderVerificationSuccess = () => {
        return (React.createElement(View, { style: styles.successCard },
            Platform.OS === 'ios'
                && React.createElement(LottieView, { source: { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }, style: { width: 70, height: 70 }, autoPlay: true, loop: true }),
            Platform.OS !== 'ios'
                && successLottie !== ""
                && React.createElement(LottieView, { source: successLottie, style: { width: 70, height: 'auto' }, autoPlay: true, loop: true }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: "Agreement submitted!", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: routeObj.routeId === "DASHBOARD" ? 'You are almost done! Please go to the dashboard to withdraw your funds.' :
                        'Continue to setup AutoPay to make your interest payments automatically', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { id: "bt_AgreementInit_continue", type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: routeObj.routeId === "DASHBOARD" ? 'Proceed to Dashboard' : 'Go to AutoPay', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        triggerAction({
                            ...verificationSuccessAction,
                        });
                    } }))));
    };
    const renderVerificationFailure = () => {
        return (React.createElement(View, { style: styles.successCard },
            React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: "Agreement setup failed", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'Bank account must be linked for AutoPay. Please try again.', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { id: "bt_AgreementInit_continueToTryAgain", type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Continue to try again', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setCloseFailureCard(true);
                    } }))));
    };
    const renderWaitingHalfCard = () => {
        return (React.createElement(View, { style: styles.successCard },
            React.createElement(Icon, { name: IconTokens.Redirecting, size: IconSizeTokens.Size56 }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: "Waiting for response", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "Please wait while we process your request", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { id: "bt_AgreementInit_continue", type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Continue", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        triggerAction({
                            ...pollAgreementStatusAction,
                            payload: {
                                value: urlData
                            }
                        });
                    } }))));
    };
    return (React.createElement(View, { style: [styles.container, { height: height - 16 }] },
        React.createElement(View, { style: styles.headerStyle }, _headerChild),
        showWebView ?
            React.createElement(WV, { id: 'iframe', style: {
                    width: Dimensions.get('window').width,
                    height: height - 150,
                }, automaticallyAdjustContentInsets: false, javaScriptEnabled: true, domStorageEnabled: true, startInLoadingState: true, useWebKit: true, originWhitelist: ['*'], allowsInlineMediaPlayback: true, scalesPageToFit: Platform.OS === 'android', scrollEnabled: true, mediaPlaybackRequiresUserAction: false, javaScriptEnabledAndroid: true, source: { uri: urlData }, showsHorizontalScrollIndicator: false, nestedScrollEnabled: Platform.OS !== "web" })
            : React.createElement(View, { style: { paddingHorizontal: 16, marginTop: 16 } },
                React.createElement(Typography, { label: 'Review agreement', fontWeight: '700', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24 }),
                React.createElement(View, { style: { marginTop: 8 } },
                    React.createElement(Typography, { label: 'Verify and confirm the usage terms & charges', fontWeight: '400', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Charcoal })),
                React.createElement(View, { style: {
                        justifyContent: 'center',
                        alignContent: 'center',
                        alignSelf: 'center',
                        height: height - 300
                    } },
                    React.createElement(ShimmerIcon, { icon: {
                            name: IconTokens.ContractFile,
                            size: IconSizeTokens.XXXXXXXXL,
                        }, name: 'Freebook', size: ShimmerIconSizeTokens.XXXXXL, borderRadius: BorderRadiusTokens.BR0, padding: SizeTypeTokens.SM }))),
        React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                justifyContent: 'center',
                width: '100%',
                paddingBottom: 16,
                paddingHorizontal: 16,
                backgroundColor: 'white'
            } },
            React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: "Confirm", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, width: ButtonWidthTypeToken.FULL, loading: loading, onPress: () => {
                    Platform.OS === "web" ?
                        triggerAction({
                            ...continueAction,
                            payload: {
                                value: urlData,
                                widgetId: 'input',
                                isResend: false,
                            }
                        }) : triggerAction({
                        ...openTabAction,
                        payload: {
                            value: urlData,
                            widgetId: 'input',
                            isResend: false,
                        }
                    });
                } })),
        (showClickForAgreementCard || showWaitingForResponseCard || showAgreementCompleteStatus || showAgreementFailureStatus) && renderVerification()));
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: -16
    },
    bodyContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column',
        flex: 1,
        padding: 8
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    headerStyle: {
        ...Platform.OS === "ios" && {
            marginTop: 24
        }
    },
    successCard: {
        alignItems: "center", flex: 1, height: 260, padding: 16
    },
    successLottie: { width: 70, height: 'auto' },
    halfCardTitle: { marginTop: 16 },
    halfCardDescription: { marginTop: 4 },
    successCTA: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        paddingHorizontal: 16,
        marginBottom: 16,
        marginTop: 24,
    },
});
// @ts-ignore
export default (AgreementInit);
